import { h } from '@atomify/jsx';
import { ButtonLoader } from '@atoms/button-loader';
import { BPDFunctionalSvg } from '@atoms/svg/svg';

export interface ButtonRoundInterface {
    variant?: 'dark' | 'light' | 'grey-5';
    classes?: string;
    hook?: string;
    attributes?: {};
    ariaLabel: string;
    svg?: string;
    onClick?: Function;
    url?: string;
    disabled?: boolean;
    hasLoading?: boolean;
    loadableModal?: string;
    children?: Element;
    element?: string;
    size?: 'small' | 'large';
}

const createClassName = (data: ButtonRoundInterface) => {
    return {
        ['c-button-round']: true,
        ...(data.variant && { [`button-round--${data.variant}`]: true }),
        ...(data.size && { [`button-round--${data.size}`]: true }),
        ...(data.classes && { [data.classes]: true }),
    };
};

const createAttributes = (data: ButtonRoundInterface) => {
    return {
        ['aria-label']: data.ariaLabel,
        ...data.attributes,
        ...(data.url && { href: data.url }),
        ...(data.onClick && { onClick: data.onClick }),
        ...(data.disabled && { disabled: data.disabled }),
        ...(data.hook && { [`js-hook-${data.hook}`]: data.hook }),
        ...(data.loadableModal && { [`js-hook-loadable-modal`]: data.loadableModal }),
    };
};

const ButtonRound = (data: ButtonRoundInterface): Element => {
    const className = createClassName(data);
    const attributes = createAttributes(data);

    const Tag = `${data.element || 'button'}`;

    return (
        <Tag className={className} {...attributes}>
            {data.svg && <BPDFunctionalSvg name={data.svg} />}
            {data.children && <span class="button-round__label">{data.children}</span>}
            {(data.hasLoading || data.loadableModal) && <ButtonLoader />}
        </Tag>
    );
};

const ButtonRoundA = ({ children, ...data }: ButtonRoundInterface): Element => {
    return (
        <ButtonRound {...data} element="a">
            {children}
        </ButtonRound>
    );
};

export { ButtonRound, ButtonRoundA };
